import { request } from '@h3/request';
import { H3 } from '@h3/types';

/** 分页加载子管理员列表 */
export const loadSubAdministrators = (params: H3.Permission.ILoadSubAdministratorsParams) =>
    request<H3.Http.Response.H3Response<H3.Permission.ILoadSubAdministratorsResponse>>('/v1/acl/subadmins/search', {
        method: 'post',
        data: params,
    });

/** 批量新增或更新子管理员 */
export const saveSubAdministrators = (params: H3.Permission.ISaveSubAdministratorsParams) =>
    request<H3.Http.Response.H3Response<boolean>>('/v1/acl/subadmins', {
        method: 'post',
        data: params,
    });

/** 批量追加子管理员可管理应用 */
export const appendSubAdministratorApps = (params: H3.Permission.IAppendSubAdministratorAppsParams) =>
    request<H3.Http.Response.H3Response<boolean>>('/v1/acl/subadmins/apps/append', {
        method: 'post',
        data: params,
    });

/** 获取当前用户的子管理员权限配置 */
export const getCurrentSubAdministrator = (params: { userId: string }) =>
    request<H3.Http.Response.H3Response<H3.Permission.ISubAdministratorItem>>('/v1/acl/subadmins/current', {
        method: 'get',
        params,
    });

/** 批量删除子管理员 */
export const deleteSubAdministrators = (params: H3.Permission.IUserIdsParams) =>
    request<H3.Http.Response.H3Response<boolean>>('/v1/acl/subadmins/delete', {
        method: 'post',
        data: params,
    });

/** 获取系统角色 */
export const getSystemRoles = () =>
    request<H3.Http.Response.H3Response<H3.Permission.IRoleItem[]>>('/v1/acl/systemroles', {
        method: 'get',
    });

/** 获取角色分组列表 */
export const getRoleGroups = () =>
    request<H3.Http.Response.H3Response<H3.Permission.IRoleGroupItem[]>>('/v1/acl/rolegroups', {
        method: 'get',
    });

/** 新增角色分组 */
export const createRoleGroup = (params: H3.Permission.ICreateRoleGroupParams) =>
    request<H3.Http.Response.H3Response<H3.Permission.ICreateRoleGroupResponse>>('/v1/acl/rolegroups', {
        method: 'post',
        data: params,
    });

/** 删除角色分组 */
export const deleteRoleGroup = (params: H3.Permission.IDeleteRoleGroupParams) =>
    request<H3.Http.Response.H3Response<H3.Permission.IDeleteResponse>>('/v1/acl/rolegroups/delete', {
        method: 'post',
        data: params,
    });

/** 修改角色分组 */
export const updateRoleGroup = (params: H3.Permission.IUpdateRoleGroupParams) =>
    request<H3.Http.Response.H3Response<boolean>>('/v1/acl/rolegroups/update', {
        method: 'post',
        data: params,
    });

/** 更新角色分组排序 */
export const sortRoleGroups = (params: H3.Permission.ISortRoleGroupsParams) =>
    request<H3.Http.Response.H3Response<boolean>>('/v1/acl/rolegroups/sort', {
        method: 'post',
        data: params,
    });

/** 获取分组下角色 */
export const getRoles = (params: H3.Permission.ILoadRolesParams = {}) =>
    request<H3.Http.Response.H3Response<H3.Permission.IRoleItem[]>>('/v1/acl/roles', {
        method: 'get',
        params,
    });

/** 新增角色 */
export const createRole = (params: H3.Permission.ICreateRoleParams) =>
    request<H3.Http.Response.H3Response<H3.Permission.ICreateRoleResponse>>('/v1/acl/roles', {
        method: 'post',
        data: params,
    });

/** 删除角色 */
export const deleteRole = (params: H3.Permission.IDeleteRoleParams) =>
    request<H3.Http.Response.H3Response<H3.Permission.IDeleteResponse>>('/v1/acl/roles/delete', {
        method: 'post',
        data: params,
    });

/** 修改角色 */
export const updateRole = (params: H3.Permission.IUpdateRoleParams) =>
    request<H3.Http.Response.H3Response<boolean>>('/v1/acl/roles/update', {
        method: 'post',
        data: params,
    });

/** 更新角色排序 */
export const sortRoles = (params: H3.Permission.ISortRolesParams) =>
    request<H3.Http.Response.H3Response<boolean>>('/v1/acl/roles/sort', {
        method: 'post',
        data: params,
    });

/** 获取角色可管理应用及应用权限配置摘要 */
export const getRoleApps = (params: H3.Permission.ILoadRoleAppsParams) =>
    request<H3.Http.Response.H3Response<Record<string, boolean>>>('/v1/acl/roles/apps', {
        method: 'get',
        params,
    });

/** 获取角色在指定应用下已配置权限的节点编码 */
export const getRoleAppSchemas = (params: H3.Permission.IRoleAppPermissionParams) =>
    request<H3.Http.Response.H3Response<string[]>>('/v1/acl/roles/apps/schemas', {
        method: 'get',
        params,
    });

/** 加载角色权限子节点 */
export const getRoleAclChildren = (data: H3.Permission.ILoadRoleAclChildrenParams) =>
    request<H3.Http.Response.H3Response<H3.Permission.IRoleChildNode[]>>('/v1/acl/roles/acls/children', {
        method: 'post',
        data,
    });

/** 加载角色权限节点 */
export const getRoleAclNode = (params: H3.Permission.ILoadRoleAclNodeParams) =>
    request<H3.Http.Response.H3Response<H3.Permission.IRoleAclNode>>('/v1/acl/roles/acls/node', {
        method: 'get',
        params,
    });

/** 批量保存角色权限节点 */
export const saveRoleAclNodes = (params: H3.Permission.ISaveRoleAclNodesParams) =>
    request<H3.Http.Response.H3Response<boolean>>('/v1/acl/roles/acls/nodes', {
        method: 'post',
        data: params,
    });

/** 分页加载角色成员 */
export const loadRoleMembers = (params: H3.Permission.ILoadRoleMembersParams) =>
    request<H3.Http.Response.H3Response<H3.Permission.ILoadRoleMembersResponse>>('/v1/acl/roles/members', {
        method: 'get',
        params,
    });

/** 搜索角色成员 */
export const searchRoleMembers = (params: H3.Permission.ISearchRoleMembersParams) =>
    request<H3.Http.Response.H3Response<H3.Permission.ILoadRoleMembersResponse>>('/v1/acl/roles/members/search', {
        method: 'get',
        params,
    });

/** 移除角色成员 */
export const removeRoleMembers = (params: H3.Permission.IUpdateRoleMembersParams) =>
    request<H3.Http.Response.H3Response<boolean>>('/v1/acl/roles/members/remove', {
        method: 'post',
        data: params,
    });

/** 追加角色成员 */
export const appendRoleMembers = (params: H3.Permission.IUpdateRoleMembersParams) =>
    request<H3.Http.Response.H3Response<boolean>>('/v1/acl/roles/members/append', {
        method: 'post',
        data: params,
    });

/** 加载岗位服务部门 */
export const getRolePostDepartments = (params: H3.Permission.ILoadRolePostDepartmentsParams) =>
    request<H3.Http.Response.H3Response<H3.Permission.IRolePostDepartmentResponse>>(
        '/v1/acl/roles/members/post-departments',
        {
            method: 'get',
            params,
        },
    );

/** 更新岗位服务部门 */
export const updateRolePostDepartments = (params: H3.Permission.IUpdateRolePostDepartmentsParams) =>
    request<H3.Http.Response.H3Response<H3.Permission.IRolePostDepartmentResponse>>(
        '/v1/acl/roles/members/post-departments/update',
        {
            method: 'post',
            data: params,
        },
    );

/** 复制角色 */
export const copyRole = (params: H3.Permission.ICopyRoleParams) =>
    request<H3.Http.Response.H3Response<H3.Permission.ICreateRoleResponse>>('/v1/acl/roles/copy', {
        method: 'post',
        data: params,
    });

/** 外部角色同步 */
export const synchronizeRoles = () =>
    request<H3.Http.Response.H3Response<boolean | H3.Permission.IRoleSynchronizationError>>('/v1/toolkit/role/sync', {
        method: 'post',
        data: {},
        disableBizError: true,
    });
